const StatusService = {};

StatusService.isAPIAvailable = (memberStatus, companyContactStatus) => {
    return memberStatus !== 'ERROR' && companyContactStatus !== 'ERROR';
};

export default StatusService;
